import React, { PropsWithChildren } from "react"
import { PropsWithStyle } from "@rogue_4/types"
import classNames from "classnames"

import styles from "./index.module.less"

const ToastContainer = React.forwardRef<
    HTMLDivElement,
    PropsWithChildren<PropsWithStyle<{ active: boolean }>>
>(({ className, style, children, active }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(
                styles.toast,
                active && styles.active,
                className
            )}
            style={style}
        >
            <div className={styles.content}>{children}</div>
        </div>
    )
})
ToastContainer.displayName = "Toast"

export default ToastContainer
